/** "just now", "4 min ago", "3 h ago", "2 d ago"; future dates: "in 9 min". */
export const formatRelative = (date: Date, now: number = Date.now()): string => {
  const diff = Math.round((date.getTime() - now) / 1000)
  const abs = Math.abs(diff)
  const fmt = (value: number, unit: string) => (diff < 0 ? `${value} ${unit} ago` : `in ${value} ${unit}`)
  if (abs < 45) return "just now" // also absorbs small clock skew
  if (abs < 3600) return fmt(Math.round(abs / 60), "min")
  if (abs < 86_400) return fmt(Math.round(abs / 3600), "h")
  return fmt(Math.round(abs / 86_400), "d")
}

/** "9:41" style countdown for short expiries. */
export const formatCountdown = (ms: number): string => {
  const total = Math.max(0, Math.floor(ms / 1000))
  const minutes = Math.floor(total / 60)
  const seconds = total % 60
  return `${minutes}:${seconds.toString().padStart(2, "0")}`
}

/** "Oct 11": the app's short date (month and day, English like the rest of the copy). */
export const shortDay = (ms: number): string =>
  new Date(ms).toLocaleDateString("en-US", { month: "short", day: "numeric" })

/** "11:46": a 24-hour clock time. */
export const clockTime = (ms: number): string => {
  const d = new Date(ms)
  return `${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`
}

/** "Oct 11, 11:46": the short date and time the app uses for revisions and activity. */
export const shortDateTime = (ms: number): string => `${shortDay(ms)}, ${clockTime(ms)}`
